module.exports = __webpack_public_path__ + "img/center-tube-1_130x70.1c67244c.png";